import * as types from '../mutation-types'

export default {
	namespaced: true,

	state: {
		statscticsEmployeeOverview: []
	},

	actions: {
		fetchEmpOverViewStat ({ commit }, { userIds, fromDate, toDate }) {
			const formData = new FormData();
			formData.append('from_date', fromDate);
			formData.append('to_date', toDate);
			if (userIds.length > 0) {
				userIds.forEach(id => {
					formData.append('user_ids[]', id);
				});
			}
			const params = new URLSearchParams(formData);
			return window.axios.get('/stats/employee-overview', { params })
		},

		fetchMonthlyReport ({ commit }, { fromDate, toDate }) {
			return window.axios.get('/Statistics/MonthlyReport', { params: { fromDate, toDate } }).then((data) => {
				return data
			})
		},

		fetchUserSalaryStatics ({ commit }, { id, fromDate, toDate, daysDivider, leavesDuringThisPeriod }) {
			return window.axios.get(`/Statistics/UserSalaryStatics/${id}`, { params: { fromDate, toDate, daysDivider, leavesDuringThisPeriod } }).then(({ data }) => {
				return data
			})
		},

		// fetchHourForEmployee ({ commit }, { id, fromDate, toDate }) {
		// 	return window.axios.get(`/Statistics/UserWorkAverage/${id}`, { params: { fromDate, toDate } }).then(({ data }) => {
		// 		return data
		// 	})
		// },

		fetchProjectForEmployee ({ commit }, { id, projectId, fromDate, toDate, annualy, withEmptyDates, withoutDuplicate }) {
			return window.axios.get(`/Statistics/UserProjectStatics/${id}`, { params: { projectId, fromDate, toDate, annualy, withEmptyDates, withoutDuplicate } }).then(({ data }) => {
				return data
			})
		},
	
		// fetchProjectHours ({ commit }, { versionId, projectId, annual, userId, fromDate, toDate }) {
		// 	return window.axios.get('/UserStatics/ProjectHours', { 
		// 		params: { versionId, projectId, annual, userId, fromDate, toDate } 
		// 	}).then(({ data }) => {
		// 		return data
		// 	})
		// }

		// for user profile
		fetchUserStatics ({ commit }, { fromDate, toDate }) {
			return window.axios.get('/UserStatics/StaticsAverage', { params: { fromDate, toDate } }).then(({ data }) => {
				return data
			})
		},
		
		fetchProjectTasksWorkHours ({ commit }, { fromDate, toDate, projectIds, userIds, categoryId }) {
			const urlSearchParams = new URLSearchParams();
			const params = { fromDate, toDate, categoryId }
			Object.keys(params).forEach(param => {
				if (params[param] !== null && params[param] !== undefined) urlSearchParams.append(param, params[param])
			});
			projectIds.forEach(id => {
				urlSearchParams.append('projectIds', id)
			})
			userIds.forEach(id => {
				urlSearchParams.append('userIds', id)
			})
			return window.axios.get('/Statistics/ProjectTasksWorkHours', { params: urlSearchParams }, {
				headers: { 'Content-Type': 'application/json' }
			}).then(({ data }) => {
				return data
			})
		},

		// new 
		// GET for multi project
		fetchPerformanceRate ({ commit }, { userId, fromDate, toDate, versionId, projectId, annual }) {
			return window.axios.get('/UserStatics/ProjectDateWorkHours', { 
				params: { userId, fromDate, toDate, versionId, projectId, annual } 
			}).then(({ data }) => {
				return data
			})
		},
		// hours in home and office
		fetchEmployeeStatics ({ commit }, { fromDate, toDate, userId, annualy }) {
			return window.axios.get('/UserStatics/EmployeeStatics', { params: { fromDate, toDate, userId, annualy } }).then(({ data }) => {
				return data
			})
		},
		// performance rate
		fetchHourForEmployee ({ commit }, { userId, fromDate, toDate, annualy, withEmptyDates }) {
			return window.axios.get('/UserStatics/PerformanceRate', { 
				params: { userId, fromDate, toDate, annualy, withEmptyDates } 
			}).then(({ data }) => {
				return data
			})
		},
		// tags
		fetchEmployeeTags ({ commit }, { userId, tagId, fromDate, toDate, annualy, withoutDuplicate }) {
			return window.axios.get('/UserStatics/EmployeeTags', { 
				params: { userId, tagId, toDate, fromDate, annualy, withoutDuplicate } 
			}).then(({ data }) => {
				return data
			})
		}
		
	},

	mutations: {
		[types.STORE_STATSCTICS_EMPLOYEE_OVERVIEW] (state, statscticsEmployeeOverview) {
			state.statscticsEmployeeOverview = statscticsEmployeeOverview
		}
	}
}
